import React, { useEffect, useState } from 'react'
import { formatDriverName } from '../../utils/driverName'
import ModalLayout from '../shared/ModalLayout'
import AddAnotherDayActivityFooter from './AddAnotherDayActivitFooter'
import AddAnotherDayActivityHeader from './AddAnotherDayActivityHeader'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useDayEvents } from '../../hooks/useDayEvents'
import { DateField } from '@/ui/form/controls/DateField'
import useFormatDate from '../../hooks/useFormatDate'
import useDriverService from '../../services/DriverService'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddAnotherDayActivityModal = ({
  close,
  companyId,
  selectedDay,
  driverId,
}) => {
  const { t } = useLocalize()
  const [selectedDriver, setSelectedDriver] = React.useState(null)
  const { handleInsertActivityFromAnotherDay } = useDayEvents()
  const [selectedDate, setSelectedDate] = React.useState('')
  const { getDrivers } = useDriverService()
  const [drivers, setDrivers] = useState<any | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isError, setIsError] = useState<boolean>(false)

  React.useEffect(() => {
    document.body.setAttribute('data-modal-open', 'true')

    return () => {
      document.body.removeAttribute('data-modal-open')
    }
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setIsError(false)
      try {
        const data = await getDrivers({ companyId, onlyActive: true })
        setDrivers(data)
      } catch (error) {
        setIsError(true)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  const [errorMessage, setErrorMessage] = useState('')
  const { formatDate } = useFormatDate()
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setErrorMessage('')

    try {
      if (!selectedDriver || !selectedDate) {
        setIsLoading(false)
        setErrorMessage(t('driverModule.all-fields-required'))
        return
      }
      if (driverId && selectedDriver.id === driverId) {
        setIsLoading(false)
        setErrorMessage(t('driverModule.cannot-select-same-driver'))

        return
      }
      await handleInsertActivityFromAnotherDay(
        companyId,
        selectedDriver.id,
        [selectedDate],
        driverId,

        formatDate(selectedDay.activityDayLocalTimeDate),
      )
      close()
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setErrorMessage('')
  }, [selectedDate])

  return (
    <ModalLayout>
      <form
        onSubmit={handleSubmit}
        noValidate
        className="tw-relative tw-z-[10000] tw-flex tw-max-h-[90vh] tw-w-full tw-max-w-[450px] tw-flex-col tw-rounded-lg tw-bg-white tw-shadow-2xl"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {isLoading && (
          <div className="tw-absolute tw-inset-0 tw-z-[10001] tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-black tw-bg-opacity-50">
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-rounded-lg tw-bg-white tw-p-8 tw-shadow-xl">
              <div className="tw-h-12 tw-w-12 tw-animate-spin tw-rounded-full tw-border-4 tw-border-gray-200 tw-border-t-primary"></div>
              <p className="tw-text-lg tw-font-medium tw-text-gray-700">
                Pobieranie danych kierowców...
              </p>
            </div>
          </div>
        )}

        <AddAnotherDayActivityHeader close={close} />
        <div className="tw-space-y-4 tw-p-6">
          <div className="tw-relative tw-w-full">
            <FieldsetSelect
              className=""
              required
              label={t('driverModule.select-driver')}
              placeholder={
                !drivers || drivers.length === 0
                  ? t('common.loading')
                  : t('driverModule.select-driver')
              }
              value={selectedDriver?.id?.toString() || ''}
              name="driver"
              disabled={!drivers || drivers.length === 0 || isLoading}
              onChange={(e) => {
                setErrorMessage('')
                const driverId = e.target.value
                const driver = drivers.find((d) => d.id.toString() === driverId)
                if (driver) {
                  setSelectedDriver({
                    id: driver.id,
                    name: driver.fullName || formatDriverName(driver),
                    customId: driver.customId,
                  })
                }
              }}
              options={
                !drivers || drivers.length === 0
                  ? [{ label: t('common.loading'), value: '' }]
                  : drivers.map((driver) => ({
                      label: `${driver.fullName}`,
                      value: driver.id.toString(),
                    }))
              }
            />
          </div>
          <div className="tw-relative">
            <DateField
              required
              label={t('common.select-date')}
              value={selectedDate}
              setValue={(e) => setSelectedDate(e)}
              helper={t('driverModule.copy-activities-date-helper')}
            />
          </div>
          {errorMessage && (
            <p className="tw-mt-1 tw-text-sm tw-text-red-500">{errorMessage}</p>
          )}

          {isError && (
            <p className="tw-mt-1 tw-text-sm tw-text-red-500">
              {t('common.error')}
            </p>
          )}
        </div>
        <AddAnotherDayActivityFooter />
      </form>
    </ModalLayout>
  )
}

export default AddAnotherDayActivityModal
